import { addSeconds, isBefore } from "date-fns";
import * as React from 'react'
import { Select } from '../../../components/ui/Select'
import { getCommentCodeMoods, ICommentCodeMood } from './http';

interface ICommentCodeMoodSelectProps {
  value: string
  onChange: (newValue: string) => void
  label?: string
  required?: boolean
  readOnly?: boolean
}

interface ICommentCodeMoodSelectState {
  moods: ICommentCodeMood[]
}

export class CommentCodeMoodSelect extends React.Component<ICommentCodeMoodSelectProps, ICommentCodeMoodSelectState> {
  private static CachedMoods: Promise<ICommentCodeMood[]> = null
  private static CachedMoodsTTL: Date | null = null; // Cambiamos el tipo a Date





  private static LoadMoods() {


    const now = new Date();


    // const isTimeToDie = CommentCodeMoodSelect.CachedMoodsTTL && CommentCodeMoodSelect.CachedMoodsTTL.isBefore(now)
    const isTimeToDie = CommentCodeMoodSelect.CachedMoodsTTL && isBefore(CommentCodeMoodSelect.CachedMoodsTTL, now);

    if (isTimeToDie) {
      CommentCodeMoodSelect.CachedMoods = null
      CommentCodeMoodSelect.CachedMoodsTTL = null
    }

    if (!CommentCodeMoodSelect.CachedMoods) {
      CommentCodeMoodSelect.CachedMoodsTTL = addSeconds(now, 30);


      CommentCodeMoodSelect.CachedMoods = getCommentCodeMoods()
    }

    return CommentCodeMoodSelect.CachedMoods
  }

  state: ICommentCodeMoodSelectState = {
    moods: []
  }

  componentWillMount() {
    CommentCodeMoodSelect.LoadMoods()
      .then((moods) => this.setState({ moods }))
  }

  render() {
    const { value, onChange, required, readOnly, label = 'Mood' } = this.props
    const { moods } = this.state

    return (
      <Select<ICommentCodeMood, 'key'>
        label={label}
        options={moods}
        value={value}
        required={required}
        loading={moods.length <= 0}
        valueKey="key"
        labelKey="value"
        readOnly={readOnly}
        onChange={(newValue) => onChange(newValue)} />
    )
  }
}
